module.exports = __webpack_public_path__ + "resources/img/img_experdb4_m.593fae1cd52053b3a2792bf00cf15367.png";